import type { ProjectResourceChanges } from 'core/http/project/resource-updates/resource-updates.service';
import { createAction, props } from '@ngrx/store';
import { createSetErrorAction, createSetLoadingAction } from 'app/store/completed-entity-state/completed-entity-state';

export const getProjectResources = createAction('[Project Resources Request] Get Project Resources');
export const saveProjectResources = createAction('[Project Resources Store] Save Project Resources', props<{ resources: ProjectResourceChanges }>());
export const markProjectResourcesLoaded = createAction('[Project Resources Store] Mark Project Resources Loaded');
export const setError = createSetErrorAction('[Project Resources Store] Set Error');
export const setLoading = createSetLoadingAction('[Project Resources Store] Set Loading');
